/* istanbul ignore file */
import React from 'react';
import _map from 'lodash/map';
import Skeleton from '@mui/material/Skeleton';
import { FlexDiv } from 'components/Div/styles';
import { SidebarListItem } from './ModalStyles';

export const SidebarSkeleton = () => (
  <>
    {_map(Array.from(Array(6).keys()), index => (
      <SidebarListItem key={index} data-automation="SidebarSkeleton">
        <Skeleton variant="text" animation="wave" height={14.4} width={180} />
        <FlexDiv style={{ gap: '0.5rem', alignItems: 'center' }}>
          <Skeleton variant="circular" animation="wave" height={12} width={12} />
          <Skeleton variant="text" animation="wave" height={14.4} width={60} />
        </FlexDiv>
      </SidebarListItem>
    ))}
  </>
);
